import { getCountryInfo, getTaxTableData, getDetailRecord } from "@/api/payManage/googleTax";
import { onMounted, reactive, ref } from 'vue';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import ExcelUtil from "../../../common/ExcelUtil";

export const useGoogleTaxManage = () => {
  const filterForm = reactive<any>({
    countryInf: undefined,
    currency: undefined,
  })
  const page = reactive<any>({
    current: 1,
    pageSize: 10,
    total: 0,
  })
  const addNewCountryModelRef = ref<any>(null)
  const currentTableData = ref<any[]>([])
  const originTableData = ref<any[]>([])
  const detailInfList = ref<any[]>([])
  const currentDetailRecord = ref<any>({})
  const countryInfo = ref<any[]>([])
  const exportLoading = ref(false)
  const columns = ref<any[]>([
    {
      title: '序号',
      key: 'id',
      dataIndex: 'id',
    },
    {
      title: '国家',
      key: 'country',
      dataIndex: 'country',
    },
    {
      title: 'ISO码',
      key: 'regionCode',
      dataIndex: 'regionCode',
    },
    {
      title: '币种',
      key: 'currency',
      dataIndex: 'currency',
    },
    {
      title: '税率',
      key: 'taxRate',
      dataIndex: 'taxRate',
    },
    {
      title: '操作',
      key: 'action',
    },
  ])
  const open = ref(false);
  const detailOpen = ref(false);

  const handleReset = () => {
    filterForm.countryInf = undefined
    filterForm.currency = undefined
    currentTableData.value = [...originTableData.value]
    page.current = 1
    page.total = originTableData.value.length
  }
  const handleSearch = () => {
    let filteredData = [...originTableData.value]

    if (!filterForm.countryInf && !filterForm.currency) {
      handleReset()
      return
    } else if (filterForm.countryInf && !filterForm.currency) {
      filteredData = filteredData.filter(item => item.country.includes(filterForm.countryInf) || item.regionCode.includes(filterForm.countryInf))
    } else if (!filterForm.countryInf && filterForm.currency) {
      filteredData = filteredData.filter(item => item.currency.includes(filterForm.currency))
    } else {
      filteredData = filteredData.filter(item => item.country.includes(filterForm.countryInf) && item.currency.includes(filterForm.currency))
    }

    currentTableData.value = filteredData
    page.total = filteredData.length
    page.current = 1
  }
  const handleAddNewCountry = () => {
    addNewCountryModelRef.value.resetData()
    open.value = true
  }
  const handleExport = () => {
    exportLoading.value = true
    setTimeout(() => {
      ExcelUtil.exportExcel(
        columns.value.filter((item: any) => item.key !== 'action'),
        currentTableData.value,
        `谷歌税率报表.xlsx`,
        false,
        [],
        () => {
          exportLoading.value = false
        },
      )
    }, 300) // 触发loading效果
  }
  const handlePageChange = (current: number) => {
    page.current = current
  }
  const handleShowSizeChange = (current: number, pageSize: number) => {
    page.current = 1
    page.pageSize = pageSize
  }
  const handleCloseModel = () => {
    open.value = false
    getTaxTableData({
      payChnl: "google"
    }).then((res: any) => {
      if (res.code === '0') {
        originTableData.value = res.data.list
        currentTableData.value = res.data.list
        page.current = 1
        page.total = res.data.total
        handleSearch()
      } else {
        originTableData.value = []
        currentTableData.value = []
        page.current = 1
        page.total = 0
        handleSearch()
      }
    })
  }
  const handleCloseDetailModel = () => {
    detailOpen.value = false
    getTaxTableData({
      payChnl: "google"
    }).then((res: any) => {
      if (res.code === '0') {
        originTableData.value = res.data.list
        currentTableData.value = res.data.list
        page.total = res.data.total
        handleSearch()
      } else {
        originTableData.value = []
        currentTableData.value = []
        page.current = 1
        page.total = 0
        handleSearch()
      }
    })
  }

  const filterOption = (input: string, option: any) => {
    const optionValue = option.value?.toString().toLowerCase() || '';
    const optionLabel = option.label?.toString().toLowerCase() || '';
    const searchValue = input.toLowerCase();

    return optionValue.includes(searchValue) || optionLabel.includes(searchValue);
  };
  const handleDetail = (record: any) => {
    detailOpen.value = true
    currentDetailRecord.value = record
    getDetailRecord({
      bizId: record.id,
      bizType: '税率管理'
    }).then((res: any) => {
      if (res.code === '0') {
        detailInfList.value = res.data
      } else {
        detailInfList.value = []
      }
    })
  }
  onMounted(() => {
    getCountryInfo().then((res: any) => {
      if (res.code === '0') {
        countryInfo.value = res.data.list;
      } else {
        countryInfo.value = [];
      }
    });
    getTaxTableData({
      payChnl: "google"
    }).then((res: any) => {
      if (res.code === '0') {
        originTableData.value = res.data.list
        currentTableData.value = res.data.list
        page.current = 1;
        page.pageSize = 10;
        page.total = res.data.total
      } else {
        originTableData.value = []
        currentTableData.value = []
        page.current = 1;
        page.pageSize = 10;
        page.total = 0
      }
    })
  });


  return {
    page,
    columns,
    currentTableData,
    originTableData,
    filterForm,
    addNewCountryModelRef,
    open,
    detailOpen,
    countryInfo,
    detailInfList,
    currentDetailRecord,
    exportLoading,
    filterOption,
    handleReset,
    handleSearch,
    handleAddNewCountry,
    handleExport,
    handlePageChange,
    handleShowSizeChange,
    handleCloseModel,
    handleDetail,
    handleCloseDetailModel
  }

}

